import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export const Footer = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].footer;
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | null>(null);
  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      <footer className="w-full bg-white pt-20" data-id="element-107" data-mp="37xxily2sakn">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col items-center" data-id="element-108" data-mp="3levih6kghoia">
          <h2 className="font-serif-display text-4xl md:text-5xl uppercase tracking-widest text-[#1a1a1a] mb-4" data-id="element-109" data-mp="3qd6r5dz0lsyx">
            Cenia Badillo
          </h2>
          <span className="uppercase tracking-widest text-xs font-medium text-[#c9a96e] mb-12" data-id="element-110" data-mp="29xm0ypkw16jm">
            {t.brokerage}
          </span>

          <div className="w-full h-px bg-[#c9a96e]/30 mb-16" data-id="element-111" data-mp="3l9k7bh9idvfe" />

          <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left mb-16" data-id="element-112" data-mp="3l9sjt81pyyq2">
            {/* Quick Links */}
            <div className="flex flex-col items-center md:items-start" data-id="element-113" data-mp="3v7gexz38m88r">
              <h4 className="uppercase tracking-widest text-xs font-medium text-[#1a1a1a]/50 mb-6" data-id="element-114" data-mp="3v5n74ggw1hz6">
                {t.quickLinks}
              </h4>
              <div className="flex flex-col space-y-4" data-id="element-115" data-mp="828mc4dy418m">
                {['properties', 'about', 'services', 'neighborhoods'].map(item => <button key={item} onClick={() => scrollToSection(item)} className="text-sm text-[#1a1a1a] hover:text-[#c9a96e] transition-colors uppercase tracking-wider" data-id="element-116" data-mp="hsttwhblkg3o">
                      {translations[lang].nav[item as keyof (typeof translations)['en']['nav']]}
                    </button>)}
              </div>
            </div>

            {/* Contact */}
            <div className="flex flex-col items-center md:items-start" data-id="element-117" data-mp="yruzmehxdfl5">
              <h4 className="uppercase tracking-widest text-xs font-medium text-[#1a1a1a]/50 mb-6" data-id="element-118" data-mp="13rpoydm1xx43">
                {t.contact}
              </h4>
              <div className="flex flex-col space-y-4 text-sm text-[#1a1a1a]" data-id="element-119" data-mp="1clumtgzls8t4">
                <a href="tel:6513872889" className="hover:text-[#c9a96e] transition-colors" data-id="element-120" data-mp="1cnyu88wpnpy5">
                  651.387.2889
                </a>
                <a href="mailto:contact@ceniabadillo.com" className="hover:text-[#c9a96e] transition-colors" data-id="element-121" data-mp="1mhxsgwtnypkt">
                  contact@ceniabadillo.com
                </a>
                <p className="text-[#1a1a1a]/70" data-id="element-122" data-mp="3t9q3pthhx4pc">
                  Coldwell Banker Realty
                  <br data-id="element-123" data-mp="2aevg9zetc08y" />
                  Minnesota
                </p>
              </div>
            </div>

            {/* Legal / Social */}
            <div className="flex flex-col items-center md:items-start" data-id="element-124" data-mp="25mu5yj17gjlk">
              <h4 className="uppercase tracking-widest text-xs font-medium text-[#1a1a1a]/50 mb-6" data-id="element-125" data-mp="21m0jlu3evcus">
                Legal
              </h4>
              <div className="flex flex-col space-y-4" data-id="element-126" data-mp="1wpjtwvgkcqfl">
                <button onClick={() => setModalContent('privacy')} className="text-sm text-[#1a1a1a] hover:text-[#c9a96e] transition-colors uppercase tracking-wider" data-id="element-127" data-mp="2te9e4sfnxv4q">
                  {t.privacy}
                </button>
                <button onClick={() => setModalContent('terms')} className="text-sm text-[#1a1a1a] hover:text-[#c9a96e] transition-colors uppercase tracking-wider" data-id="element-128" data-mp="2fegpr3rlzqzx">
                  {t.terms}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="w-full bg-[#1a1a1a] py-6" data-id="element-129" data-mp="2rug6bmx89urx">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-130" data-mp="2wmzjwjvx0pwq">
            <p className="text-white/50 text-xs tracking-wider" data-id="element-131" data-mp="2iwmbkgf4396v">{t.rights}</p>

            <div className="flex items-center space-x-6" data-id="element-132" data-mp="2nv7amcimnmtq">
              <span className="text-white/50 text-xs border border-white/20 px-2 py-1 rounded-sm" title="Equal Housing Opportunity" data-id="element-133" data-mp="3bjqi4pturvkr">
                EHO
              </span>
              <span className="text-white/50 text-xs border border-white/20 px-2 py-1 rounded-sm" title="Multiple Listing Service" data-id="element-134" data-mp="31m2fldq09js1">
                MLS
              </span>
            </div>

            <a href="tel:6513872889" className="text-[#c9a96e] text-sm tracking-widest hover:text-white transition-colors" data-id="element-135" data-mp="1q4swwtepavrs">
              651.387.2889
            </a>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <AnimatePresence data-id="element-136" data-mp="1iltbyjblcw6b">
        {modalContent && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setModalContent(null)} data-id="element-137" data-mp="1ip7crn4lwxbn">
            <motion.div initial={{
          y: 50,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: 50,
          opacity: 0
        }} onClick={e => e.stopPropagation()} className="bg-white w-full max-w-2xl max-h-[80vh] overflow-y-auto p-8 lg:p-12 relative" data-id="element-138" data-mp="zuaawi14ns6x">
              <button onClick={() => setModalContent(null)} className="absolute top-6 right-6 text-[#1a1a1a]/50 hover:text-[#1a1a1a] transition-colors" data-id="element-139" data-mp="2g9ua5pjww5tq">
                <X size={24} strokeWidth={1.5} data-id="element-140" data-mp="2q1rnp2ye79vm" />
              </button>

              <h3 className="font-serif-display text-3xl mb-6 text-[#1a1a1a]" data-id="element-141" data-mp="2v01ihcg7g8gp">
                {modalContent === 'privacy' ? t.privacy : t.terms}
              </h3>

              <div className="body-text text-sm text-[#1a1a1a]/80 space-y-4" data-id="element-142" data-mp="1xe45tvoiaxco">
                <p data-id="element-143" data-mp="22b4emecqqe7h">
                  This is a placeholder for the{' '}
                  {modalContent === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}{' '}
                  content. In a production environment, this would contain the
                  full legal text required for real estate compliance.
                </p>
                <p data-id="element-144" data-mp="3mpo3i5m0a15s">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.
                </p>
                <p data-id="element-145" data-mp="128pjlwvjm03m">
                  Duis aute irure dolor in reprehenderit in voluptate velit esse
                  cillum dolore eu fugiat nulla pariatur. Excepteur sint
                  occaecat cupidatat non proident, sunt in culpa qui officia
                  deserunt mollit anim id est laborum.
                </p>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
};